import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UiRenderer, DialogComponent } from '@m27/common';
import { LoginDialogComponent } from './login/dialog-login.component';


@Component({
    selector: 'app-dialogs',
    templateUrl: './dialog.component.html'
})
export class AppDialogsComponent extends DialogComponent {
    @ViewChild('login', { static: true }) public Login: LoginDialogComponent;

    constructor(ui: UiRenderer, router: Router, sanitizer: DomSanitizer) {
        super(ui, router, sanitizer);
    }

    initializeDialogs() {
        this.Login.initalize(this.ui, this);
    }
}

